module.exports = "<header id=top><h1><a v-link=\"{ path: '/' }\">{{ title }} /</a><a v-link=\"{ path: '/photos' }\"> PHOTOS</a></h1></header><router-view></router-view>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./public/_src/_vue/Shell.vue
 ** module id = 15
 ** module chunks = 0
 **/